<template>
	<box :customer="true" :autoLoad="true" :ref="boxRef" title="对账明细" :width="1200" :index="0" @hide="hide"
		@submit="submit" moduleName="proofbill" :store="store" selectType="checkbox" @boxdataload="boxdataload" />

</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			data: {
				type: Array,
				default: () => {
					return []
				}
			},
			supplierwlnid: {
				default: () => {
					return null
				}
			},
			billtime: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				index: 0,
				foreingKey: null,
				boxRef: 'box_' + Math.random(),
				box: null,
				boxConfig: {
					columns: [{
						type: "",
						field: 'bizTime',
						title: '业务日期',
						render: '$datePicker',
						props:{
							type:'daterange',				
						},
						slots:{
							default:({row})=>{
								return window.systemMethods.timestampToDate(row.bizTime,true) 
							}
						}		
					},{
						type: "",
						field: 'billCode',
						title: '采购/采退单',
						render: '$input',
					},{
						type: "",
						field: 'stockCode',
						title: '入库/出库单',
						render: '$input',
					},{
						type: "",
						field: 'proofbillcode',
						title: '结算单',
						render: '$input',
					},{
						type: "",
						field: 'storageName',
						title: '仓库',
						render: ''		
					},
					// {
					// 	type: "",
					// 	field: 'billType',
					// 	title: '单据类型',
					// 	render: '',
					// 	slots:{
					// 		default:({row})=>{
					// 			if(row.billType==6){
					// 				return '采购入库单'
					// 			}
					// 			if(row.billType==7){
					// 				return '采购退货单'
					// 			}
					// 			return null
					// 		}
					// 	}
					// },
					{
						type: "",
						field: 'stock_sum',
						title: '入库/出库金额',
						render: ''		
					},
					{
						type: "",
						field: 'status',
						title: '状态',
						render: '',
						slots:{
							default:({row})=>{
								if(row.status==4){
									return '关闭'
								}else if(row.status==3){
									return '完成'
								}else if(row.status==2){
									return '部分到货'
								}else{
									return '其他状态'
								}
							}
						}
					},
					{
						type: "",
						field: 'proofbillstatus',
						title: '结算状态',
						render: '',
						slots:{
							default:({row})=>{
								if(row.proofbillstatus==1){
									return '已结算'
								}else if(row.proofbillstatus==4){
									return '待审核'
								}
							}
						}
					},
					// {
					// 	type: "",
					// 	field: 'settlementStatus',
					// 	title: '结算状态',
					// 	render: '',
					// 	slots:{
					// 		default:({row})=>{
					// 			if(row.settlementStatus==1){
					// 				return '待结算'
					// 			}else if(row.settlementStatus==2){
					// 				return '已结算'
					// 			}else if(row.settlementStatus==3){
					// 				return '已结清'
					// 			}else{
					// 				return '部分结算'
					// 			}
					// 		}
					// 	}
					// },
					{
						field: 'reconciliationbillcode',
						title: '已关联对账单',
						render: '$input'
					}],
					pagerConfig: {
						currentPage: 1,
						pageSize: 20,
						enabled: true,
						pageSizes: [10,20, 50, 200],
						force: false
					},
				},

			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list = this.list
			this.box.show = this.show
			// this.box.checkMethod = ({
			// 	row
			// }) => {
			// 	return !row.reconciliationbilldetailid
			// }

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},

		methods: {
			show() {
				if (this.box.getTable()) {
					this.box.getTable().commitProxy('query')
				}
			},
			initList() {
				if (!this.box.gridOptions) {
					this.box.initBox(this.boxConfig)
				}
			},
			list(page, form, other) {
				return new Promise((resolve, reject) => {
					this.$api.reconciliationbill.getunsettlementbill(this.supplierwlnid, {
						billtime:this.billtime,
						mode: 'box',
						index: this.index,
						...page,
						...form,
						...this.foreingKey,
						...other
					}).then((res) => {

						resolve(res)
					}, () => {
						reject()
					})
				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>